import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// Remove the static SEO/crawler skeleton from index.html once React boots — it's
// only there so AI/SEO crawlers reading the raw HTML response see proper
// semantic structure + content. Users never see it (it's hidden via the
// `hidden` attribute), but we still strip it from the DOM to keep things clean.
const __skeleton = document.getElementById("static-seo-skeleton");
if (__skeleton) __skeleton.remove();

const root = ReactDOM.createRoot(document.getElementById("root"));
// No React.StrictMode: its dev-only unmount/remount simulation breaks react-helmet-async@2
// (HelmetDispatcher deregisters on unmount and never re-registers), which silently drops
// <meta name="description"> on any page whose SEOHead mounts after an async fetch.
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
